import React from "react";

import { useUiStore } from "../state/uiStore";

const GlobalContext = React.createContext();

const GlobalProvider = ({ children }) => {
  const store = useUiStore();

  return (
    <GlobalContext.Provider value={store}>{children}</GlobalContext.Provider>
  );
};

export default GlobalContext;
export { GlobalProvider, useUiStore };
